var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"apilogs"},_vm._l((_vm.logs.data),function(log){return _c('el-row',{key:log.name},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.openKibanaVisualization(log.name)}}},[_vm._v("\n        "+_vm._s(log.name)+"\n    ")])],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79b4d06d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apilogs/apilogs.vue
// module id = null
// module chunks = 